import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { RestService } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-example-monouse-component",
  template: ``,
  styles: [],
  standalone: false,
})
export class MinusWarehouseProductComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(
    private host: ElementRef<HTMLElement>,
    private loader: LoaderService,
    private message: Message,
    private rest: RestService
  ) {}

  ngOnInit(): void {
    if (this.fatherElement.stock === 0) {
      this.message.showMessage("Hai 0 prodotti", "error");
    } else {
      this.loader.on();
      this.rest.post(`/store/${this.fatherElement.id}/sub`, {}).subscribe({
        next: (value) => {
          this.message.showMessage(
            "Quantità prodotto ridotta con successo",
            "success"
          );
          this.loader.off(true);
          this.fatherContaierRef.getTableData();
          this.host.nativeElement.remove();
        },
        error: (error) => {
          this.message.showMessage(
            "Errore nella riduzione del prodotto",
            "error"
          );
          this.loader.off(true);
          this.host.nativeElement.remove();
        },
      });
    }
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
